import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

window.addEventListener(
  "error",
  (event) => {
    if (
      event.error instanceof DOMException
      && event.error.name === "DataCloneError"
      && event.message?.includes("PerformanceServerTiming")
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
